export const fr = {
    en: 'EN',
    tr: 'TR',
    fr: 'FR',
    de: 'DE',
    sports: 'Des sports',
    live: 'Live',
    today: 'Aujourd\'hui',
    highlights: 'Points forts',
    results: 'Résultats',
    lastMinute: 'Dernière minute',
    liveCasino: 'Live Casino',
    casino: 'Casino',
    myBets: 'Mes paris',
    home: 'Accueil',
    betslip: 'Pari slip',
    search: 'Chercher',
    searchHere: 'Cherche ici',
    transaction: 'Transaction',
    changePassword: 'Changer le mot de passe',
    logout: 'Se déconnecter',
    single: 'Célibataire',
    multiple: 'Plusieurs',
    possibleWin: 'Victoire possible',
    amount: 'Montant',
    ok: 'Ok',
    totalOdds: 'Cotes totales',
    totalPossibleWin: 'Gain total possible',
    placeBet: 'Parier',
    fastBet: 'Paris rapide',
    username: 'Nom d utilisateur',
    password: 'Mot de passe',
    stayLoggedIn: 'Rester connecté',
    login: 'Connexion',
    all: 'Tout',
    inGame: 'En jeu',
    won: 'A gagné',
    lost: 'Perdu',
    date: 'Date',
    winAmount: 'Montant du gain',
    stake: 'Pieu',
    pick: 'Choisir',
    myAccount: 'Mon compte',
};
